import gql from "graphql-tag"

const fragment = gql`
  fragment RewardCatalogueProduct on RewardCatalogueProduct {
    currency
    name
    price
    product {
      name
      supplier
      type
      uuid
      vat
    }
    rewardCatalogueProductId
    supplier
    type
    uuid
  }
`

export default fragment
